import type { CardData, CardTemplate, StoryDefaultPlatform } from 'types/story';
import { createBuildingBlock } from 'common/building-blocks/create-building-block';
import { COMPONENT_TYPE } from 'common/constants';
import { CardEventFactory } from 'utils/facades/templates/card-event';
import { generateCardId } from 'utils/generate-id';

interface Props {
	type: CardData['type'];
	name: string;
	defaultPlatform: StoryDefaultPlatform;
}

export function defaultTemplate({ type, name, defaultPlatform }: Props): CardTemplate {
	const cardId = generateCardId();
	// @ts-expect-error In-memory default templates have no persisted API timestamps.
	return {
		id: '',
		name: 'Blank page',
		subtitle: 'Blank template.',
		description: 'Blank template to build your card from scratch.',
		organizationId: null,
		editor: {
			card: {
				_id: cardId,
				type,
				name,

				elements: [
					createBuildingBlock(COMPONENT_TYPE.FLOAT_ABOVE, { defaultPlatform }),
					createBuildingBlock(COMPONENT_TYPE.CONTENT, { defaultPlatform }),
					createBuildingBlock(COMPONENT_TYPE.FLOAT_BELOW, { defaultPlatform }),
					createBuildingBlock(COMPONENT_TYPE.CARD, {
						cardType: type,
						defaultPlatform,
					}),
				],
				settings: {},
				events: [CardEventFactory.create('default', {})],
			},
		},
		metadata: {
			storySettings: {
				cards: {
					[cardId]: {},
				},
			},
			storyId: '',
			cardId: '',
			clientStoryId: '',
			version: process.env.VERSION as string,
			defaultPlatform,
		},
		type: 'card',
		language: '',
		categories: [],
	};
}
